import { LoadingStatusEnum } from '../../../constants/enums';
import { RootState } from '../../store';

// ----------------------------------------------------------------
const factoryOptionsSelectors = {
  list: (state: RootState) => state.factoryOptions.list,
  listUpdatingCount: (state: RootState) => state.factoryOptions.listUpdatingCount,
  loading: (state: RootState) => state.factoryOptions.loading,
  isLoading: (state: RootState) => state.factoryOptions.loading === LoadingStatusEnum.Pending,

  selectedItem: {
    data: (state: RootState) => state.factoryOptions.selectedItem.data,
    loading: (state: RootState) => state.factoryOptions.selectedItem.loading,
    isLoading: (state: RootState) => state.factoryOptions.selectedItem.loading === LoadingStatusEnum.Pending,
  },
};

export default factoryOptionsSelectors;
